export enum NotificationType {
  ProfilePendingApproval = 'ProfilePendingApproval',
  LocationsPendingApproval = 'LocationsPendingApproval',
  CarsPendingApproval = 'CarsPendingApproval',
  PriceListsPendingApproval = 'PriceListsPendingApproval',
  TermsConditionsPendingApproval = 'TermsConditionsPendingApproval',
  ProfileDocumentPendingApproval = 'ProfileDocumentPendingApproval',
}

export interface INotificationResponse {
  id: number
  messageDate: string
  companyName: string
  title: string
  message: string
  companyId: number
  notificationType: NotificationType
}

export interface IGetNotificationsResponse {
  notifications: INotificationResponse[]
}

export interface IGetNotificationCountResponse {
  notificationsCount: number
}
